import type { FC } from "react";

import { InputAdornment, Stack, TextField, Typography } from "@mui/material";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RulesTabLastOrdersRegistrationTabProps {
  forOrders?: boolean;
  max?: number;
  min?: number;
  days?: number;
  withRepeat: boolean;
  onChangeMax?: (value: number) => void;
  onChangeMin?: (value: number) => void;
  onChangeDays?: (value: number) => void;
  onToggleWithRepeat: () => void;
}

export const RulesTabLastOrdersRegistrationTab: FC<
  RulesTabLastOrdersRegistrationTabProps
> = ({
  forOrders,
  max,
  min,
  days,
  withRepeat,
  onToggleWithRepeat,
  onChangeMax,
  onChangeMin,
  onChangeDays,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack direction='column' sx={{ gap: 1.5, py: 2 }}>
      <Stack direction='row' alignItems='center' sx={{ width: 1 }}>
        <TextField
          sx={{ width: 1 }}
          type='number'
          label={
            forOrders
              ? t(
                  "campaign.notifications.settings.displayRules.lastOrders.maxLast",
                )
              : t(
                  "campaign.notifications.settings.displayRules.lastRegistrations.maxLast",
                )
          }
          variant='outlined'
          value={max}
          onChange={e => onChangeMax && onChangeMax(Number(e.target.value))}
          InputProps={{
            inputProps: { min: 0, style: { height: 10 } },
            endAdornment: (
              <InputAdornment position='end'>
                <Typography
                  style={{
                    color: theme.palette.natural.t1,
                    fontSize: 16,
                  }}
                >
                  {forOrders
                    ? t(
                        "campaign.notifications.settings.displayRules.lastOrders.orders",
                      )
                    : t(
                        "campaign.notifications.settings.displayRules.lastRegistrations.registrations",
                      )}
                </Typography>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Stack direction='row' alignItems='center'>
        <TextField
          sx={{ width: 1 }}
          type='number'
          variant='outlined'
          label={
            forOrders
              ? t(
                  "campaign.notifications.settings.displayRules.lastOrders.maxToShow",
                )
              : t(
                  "campaign.notifications.settings.displayRules.lastOrders.whenAtLeast",
                )
          }
          value={min}
          onChange={e => onChangeMin && onChangeMin(Number(e.target.value))}
          InputProps={{
            inputProps: { min: 0, style: { height: 10 } },
            endAdornment: (
              <InputAdornment position='end'>
                <Typography
                  style={{
                    color: theme.palette.natural.t1,
                    fontSize: 16,
                  }}
                >
                  {forOrders
                    ? t(
                        "campaign.notifications.settings.displayRules.lastOrders.orders",
                      )
                    : t(
                        "campaign.notifications.settings.displayRules.lastRegistrations.registrations",
                      )}
                </Typography>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Stack direction='row' alignItems='center'>
        <TextField
          sx={{ width: 1 }}
          type='number'
          variant='outlined'
          label={
            forOrders
              ? t(
                  "campaign.notifications.settings.displayRules.lastOrders.ordersLast",
                )
              : t(
                  "campaign.notifications.settings.displayRules.lastRegistrations.registrationsLast",
                )
          }
          value={days}
          onChange={e => onChangeDays && onChangeDays(Number(e.target.value))}
          InputProps={{
            inputProps: { min: 0, style: { height: 10 } },
            endAdornment: (
              <InputAdornment position='end'>
                <Typography
                  style={{
                    color: theme.palette.natural.t1,
                    fontSize: 16,
                    marginRight: forOrders ? 60 : 45,
                  }}
                >
                  {t("campaign.notifications.settings.displayRules.days")}
                </Typography>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Typography style={{ color: theme.palette.natural.t1, fontSize: 14 }}>
          {forOrders
            ? t(
                "campaign.notifications.settings.displayRules.lastOrders.notRecoginzed",
              )
            : t(
                "campaign.notifications.settings.displayRules.lastRegistrations.notRecoginzed",
              )}
        </Typography>
        <CustomSwitch checked={withRepeat} onSwitch={onToggleWithRepeat} />
      </Stack>
    </Stack>
  );
};
